module.exports = __webpack_public_path__ + "img/step-mobile.2898ac82.jpg";